export const PROJECT_EXPLORER_WIDTH = 'ProjectExplorerWidth';
export const VISUAL_PREVIEW_WIDTH = 'VisualPreviewWidth';
export const TIMELINE_HEIGHT = 'TimelineHeight';

export const VISUAL_PREVIEW_MOBILE_X = 'VisualPreviewMobileX';
export const CODE_EDITOR_MOBILE_X = 'CodeEditorMobileX';
